export const onSetHidden = (hidden) => ({
  type: 'SET_HIDDEN',
  hidden
})

export const onToggleHidden = (key) => ({
  type: 'TOGGLE_HIDDEN',
  key
})
